module.exports = __webpack_public_path__ + "img/newBox_left.67fe0609.png";